export default __webpack_public_path__ + "static/media/sti-screening.3fe2454f.svg";